const itemPrice = (item) => {
  let price = item.dough.price;
  item.ingredients.map((ingredient) => (price += ingredient.price));
  price *= item.count;
  return price;
};

const totalPrice = (cart) => {
  let price = cart.delivery;
  cart.items.map((cartItem) => {
    return (price += itemPrice(cartItem));
  });
  return price;
};

const priceEUR = (price) => {
  price = Math.round(price * 100) / 100;
  return price.toFixed(2) + " EUR";
};

const getIngredients = (ingredients) => {
  let ingredientsList = "";
  const count = ingredients.length;
  if (count === 0) return "";

  const ingredientsDescriptions = [];
  ingredients.map((ingredient) =>
    ingredientsDescriptions.push(ingredient.name)
  );
  if (count === 1) return ingredientsDescriptions[0];
  for (let i = 0; i < count; i++) {
    ingredientsList += ingredientsDescriptions[i];
    if (i < count - 2) {
      ingredientsList += ", ";
    } else if (i === count - 2) {
      ingredientsList += " and ";
    }
  }
  return ingredientsList;
};

export { totalPrice, itemPrice, priceEUR, getIngredients };
